<template>
   <!-- <div class="ThreeD_body bg" v-loading="true" element-loading-text="模型加载中" element-loading-background="rgba(0, 0, 0, 0.8)"> -->
   <div class="ThreeD_body bg">
      <div class="model_loading" v-show="modelLoading">
         <div class="model_loading_div">
            <img src="../assets/gif/loading.gif" alt="">
            <p>模型加载中</p>
         </div>
      </div>
      <!-- <div class="chooseEasy">
         modelLoading
         <el-button type="text" @click="isEggs()">测试</el-button>
      </div> -->
      <gif v-if="isGuide" class="gif"></gif>
      <div class="gif-up-box" id="gifup">
         <div class="gif-up">
            <img src="../assets/gif/point.png" alt="">
         </div>
         <div style="left: 15vh;position: absolute;width: 33vh;"><img src="../assets/gif/bottom.png" alt=""></div>
      </div>
      <btnmusic ref="threed_bgm"></btnmusic>
      <!-- 顶部 -->
      <!-- <div>{{endcamareEndX}}</div> -->
      <div class="Three_top">
         <!-- 返回栏 -->
         <div class="return bg">
            <div class="Activity_text_1" @touchend="returnHome()">
               返回
            </div>
            <div class="Activity_text_2">
               <img src="../../static/pageImg/common/common_icon_back.png" alt="">
            </div>
         </div>
         <!-- 标题 -->
         <div class="title_text bg">
            <img style="height:100%;width:100%" :src="model.titleImg" alt="">
         </div>
         <!-- 得分情况 -->
         <div class="score" v-if="isAnimateEnd">
            <div class="score_img bg" v-if="!highestIntegral">
               <p>{{integral}}</p>
            </div>
            <div class="score_img_score bg" v-else>
               <p style="text-align: right;font-size:1.5vh;padding-top:0.5vh">{{highestIntegral}}</p>
               <p style="text-align: right;font-size:2vh;padding-top:0.1vh">{{integral}}</p>
            </div>
            <div class="plan bg">
               <img :src="isPlanImg" alt="">
            </div>
         </div>
      </div>
      <!-- 3D场景 -->
      <div id="ThreeModel" style="width:100%"></div>
      <!-- 模型碎片 -->
      <transition name="plus-icon">
         <div class="box_model_card bg" id="pos" v-show="isReloadData">
            <div :class="'model_card_cell bg xxxIndex'+index" v-for="(item,index) in heidJson" :key="item.id">
               <div :class="'box-red'+index" class="box-red bg" :id="'model_'+index" v-if="!item.status" :key="item.id">
                  <img :key="item.id" :id="'img_'+index" :src="item.img" alt="" @mousemove="touchmove" @mousedown="touchstart" @mouseup="touchend" @touchmove="touchmove" @touchstart="touchstart" @touchend="touchend" @touchcancel="touchcancel" :serial-number="index">
               </div>
            </div>
         </div>
      </transition>
      <div class="grid bg"></div>
      <!-- 成功or失败 遮罩层 -->
      <!-- <div class="gameOver" v-if="isGameOver"> -->
      <div class="gameOver" v-if="isGameOver">
         <div class="gameOver_Lose" v-if="!isLoseOrSucc && isGameOver">
            <img src="../../static/pageImg/splicing/splicing_pop_defeate.png" alt="">
            <div class="restartBtn" @click="restartBtn"></div>
            <div class="returnHome" @click="returnHome"></div>
         </div>
         <div class="gameOver_Success" v-if="isLoseOrSucc && isGameOver">
            <!-- 顶部文字 -->
            <div class="top_text bg"><span>{{model.modelName}}</span>建造成功</div>
            <div class="content_box bg">
               <div class="skipBtn bg">
                  <img @click="skipBtn" src="../../static/pageImg/splicing/splicing_btn_skip.png" alt="">
               </div>
               <div class="modelShow bg" style="pointer-events:none;">
                  <img :src="model.overallModelPath" alt="">
               </div>
               <div class="maohao">“</div>
               <div class="introduceContent">
                  {{model.introduceContent}}
               </div>
               <div class="maohao maohao_right">”</div>
               <div class="bottom_box bg">
                  <div style="padding:5px" v-if="integral-highestIntegral>0">获得积分：
                     <span>
                        {{integral}}分
                     </span>
                  </div>
                  <div class="bottonTT" style="padding:5px">
                     <span v-if="integral-highestIntegral>0">已刷新今日最高纪录！</span>
                     <span v-else>低于今日最高记录，不计入成绩</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <!-- 模型动画GIF展示区域 -->
      <div class="model_gif_btn" v-show="isAnimateEnd">
         <img @click="openHint" src="../assets/tip.png" alt="">
      </div>
      <div v-show="!isHint" class="model_gif_btn2">
         <img @click="closeHint" src="../assets/spicing_slip_btn.png" alt="">
      </div>
      <el-collapse-transition>
         <div v-show="!isHint" class="isShowGif bg">
            <img :src="model.AnimateGif" alt="">
         </div>
      </el-collapse-transition>
   </div>
</template>

<script>
   // @ts-nocheck # 忽略全文
   // var scene = new THREE.Scene();
   var animatemodel = null;
   var scene = null;
   var camera = null;
   var width = window.innerWidth; // 窗口宽度
   var height = window.innerHeight * 0.7 // 窗口高度
   var renderer = null;
   var orbitControls = null;
   var pointLight = null;
   var directionalLight = null; // 直线光
   var hemiLight = null;
   var ambientLight = null;   //环境光
   var sceneDomElement = null;
   var mesh = null;
   var objects = [];
   var heidModels = [];
   // 模型动画相关
   let clock = new THREE.Clock(); // 用于clock.getDelta()
   let mixer;
   var planes;
   let curve = null;
   let progress = 0; // 物体运动时在运动路径的初始位置，范围0~1
   const velocity = 0.0001; // 影响运动速率的一个值，范围0~1，需要和渲染频率结合计算才能得到真正的速率
   var composer = null
   var outlinePass = null
   var renderPass = null
   let isGreen = false
   import * as THREE from 'three';
   import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js';
   import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
   import { DragControls } from 'three/examples/jsm/controls/DragControls.js';
   // import { TransformControls } from 'three/examples/jsm/controls/TransformControls.js';
   import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
   import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
   import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass";
   import { ShaderPass } from "three/examples/jsm/postprocessing/ShaderPass";
   import { FXAAShader } from "three/examples/jsm/shaders/FXAAShader";
   import modelImportJson from '../../static/jsonConfig/model';
   import btnmusic from './musicAudio/ButtonBGM.vue'
   import { mapState } from 'vuex';
   import gif from "../components/guide/guide.vue"
import { fa } from 'element-plus/es/locale';
   // import { Loading,Search } from '@element-plus/icons'
   // var scene = new Scene();
   // import inobounce from 'inobounce'
   export default {
      name: 'ThreeD',
      components: {
         btnmusic,
         gif
      },
      data() {
         return {
            model_loading: true,
            // 刷新模型碎片列表
            isReloadData: false,
            // 模型中的正确模型个数
            trueNum: -1,
            // 选择第几个模型？
            modelId: 0,
            // 游戏结束遮罩层
            isGameOver: false,
            isLoseOrSucc: false, // 是否刷新纪录视图
            // 鼠标Y坐标
            mouseY: 0,
            // 尺寸 角度  图片格式
            isClearScene: false,  // 是否已加载模型
            modelImportJson,   //模型json数据
            grid: null, // 地面网格
            cube: null, //网格对象cube
            plane: null,   //网格模型
            // objects: [],
            dragControls: null,
            mixer: null,
            dragObj: null,
            dragObjx: null,
            dragObjy: null,
            dragObjz: null,
            offsetX: 0,
            offsetY: 0,
            offsetXEnd: 0,
            offsetYEnd: 0,
            heidModels: [],
            model: [],  // 当前模型
            heidModelsJson: [],  // 模型碎片
            heidJson: [],
            audio: new Audio(),   // 加载音乐播放器
            // 积分规则相关
            highestIntegral: 0,  //  历史最高分
            timer: null, // 计时器
            timeNum: 0, //初始化计时时间
            integral: 0,  // 当前关卡所得积分
            continuousErrorNum: 0,  //连续失败的次数
            continuousSuccessNum: 0,  //连续成功的次数
            allSuccess: 0,  // 总的成功次数
            // 拼装进度
            planImgT: [
               { src: require('../../static/pageImg/splicing/splicing_prograss_three.png') },
               { src: require('../../static/pageImg/splicing/splicing_prograss_three_s.png') },
               { src: require('../../static/pageImg/splicing/splicing_prograss_three_ss.png') },
               { src: require('../../static/pageImg/splicing/splicing_prograss_three_sss.png') },
            ],
            planImgF: [
               { src: require('../../static/pageImg/splicing/splicing_prograss_four.png') },
               { src: require('../../static/pageImg/splicing/splicing_prograss_four_s.png') },
               { src: require('../../static/pageImg/splicing/splicing_prograss_four_ss.png') },
               { src: require('../../static/pageImg/splicing/splicing_prograss_four_sss.png') },
               { src: require('../../static/pageImg/splicing/splicing_prograss_four_ssss.png') },
            ],
            choosePlan: [],
            isPlanImg: '',
            setTime: null,
            // 测试数据
            StitchingStatus: false,
            music: {
               general: require('../../static/music/buildMu.mp3'), //  通用点击音效
               losed: require('../../static/music/losed.mp3'),  // 失败音乐
               success: require('../../static/music/successd.mp3'),  // 成功
               passsucc: require('../../static/music/pass_succ.mp3'),  // 游戏成功
               passserr: require('../../static/music/pass_err.mp3'),  // 游戏失败
            },
            endcamareEndX: '',
            sharedata: [
               "大国工程我来建｜最新出炉全国省份手速排行",
               "限时开放！“大国工程我来建”游戏挑战赛，积分有好礼",
               "十月必玩小游戏！“大国工程我来建”震撼登场",
               "十月第一份惊喜！你有一份来自大国工程的礼物待签收",
               "大国工程我来建｜这次，为梦想拼手速！",
            ],
            // 完成后取消新手引导事件
            isGuide: '',
            guideEnd: '',
            isAnimateEnd: false,
            // 高亮闪烁灯计时器
            outlineTime: null,
            islight: false,
            oldColor: null,
            DifficultToChoose: 0,
            IntegralLevel: 0,
            // 游戏信息
            gameInfo: null,
            isHint: true,
            modelLoading: true,
         }
      },
      beforeRouteEnter(to, from, next) {
         if (from.fullPath != "/") {
            next(vm => {
               vm.$router.push("/")
            })
         } else {
            next(true)
         }
      },
      created() {
         window.addEventListener('popstate', () => {
            // this.$router.push("/")
            // console.log("浏览器返回事件！",window.location.hash == "#/threed")
            if (window.location.hash == "#/threed") {
               this.$router.replace("/")
            }
         });
         const _this = this
         document.body.style.overflow = "hidden"
         const a = JSON.parse(localStorage.getItem("SETGAME"))
         this.DifficultToChoose = a.DifficultToChoose
         this.IntegralLevel = a.IntegralLevel
         this.getUserGameInfo()
         if (this.loadingStatus) {
            this.initData()
            const _this = this
            this.code = localStorage.getItem("code")
            let homeShareData = JSON.parse(JSON.stringify(_this.shareData));
            homeShareData.link = "https://activity.thepage.cn/dggcwlj/";
            let shareindex = Math.round(Math.random() * 4);
            let desc = _this.sharedata[shareindex];
            homeShareData.title = desc
            homeShareData.desc = ''
            _this.$common.onshare(JSON.parse(JSON.stringify(homeShareData)));
         }
      },
      computed: {
         ...mapState(['aid', 'userInfo', 'shareData', 'activityData', 'GetUserParams', 'loadingStatus'])
      },
      mounted() {
         if (location.href.indexOf("?reloaded") == -1) {
            location.href = location.href + "?reloaded";
            console.log("刷新")
            location.reload();
            // this.$router.go(0)
         } else {
            console.log("不刷新");
         }
         if (this.loadingStatus) {
            this.$common.pageLoaded()
            var model_Id = this.modelId
            this.getHscore(model_Id + 1)
            this.model = this.modelImportJson.model[model_Id]
            const model = this.modelImportJson.model[model_Id]
            this.modelLoading = true
            setTimeout(() => {
               this.init(model)
            }, 4000);
         }
      },
      watch: {
         continuousSuccessNum(newVal, oldVal) {
            console.log("连续成功" + newVal + "次");
            console.log("正确次数", this.trueNum);
            if (newVal == this.trueNum) {
               this.integral = this.integral + 20
               setTimeout(() => {
                  this.isGameOver = true
                  this.isLoseOrSucc = true
               }, 500)
               this.submitIntegral(this.integral)
            }
         },
         allSuccess(newVal, oldVal) {
            const _this = this
            console.log("成功" + newVal + "次,用时：", this.timeNum);
            this.stopTime()
            this.startTime()
            if (this.isPlanImg) {
               this.isPlanImg = this.choosePlan[newVal].src
            }
            if (newVal == _this.trueNum && _this.continuousSuccessNum < _this.trueNum) {
               setTimeout(() => {
                  _this.$refs.threed_bgm.playMu(_this.music.passsucc)
                  _this.stopTime()
                  _this.isGameOver = true
                  _this.isLoseOrSucc = true
               }, 300)
               _this.submitIntegral(this.integral)
            }
         },
         continuousErrorNum(newVal, olVal) {
            console.log(newVal);
            if (newVal == 50) {
               this.$refs.threed_bgm.playMu(this.music.passserr)
               this.isGameOver = true
               this.isLoseOrSucc = false
            }
         },
         isLoseOrSucc(newVal, oldVal) {
            if (newVal == true) {
               this.isEggs()
               this.setTime = setTimeout(() => {
                  try {
                     this.stopTime()
                     this.isGameOver = false
                     this.clearScene()
                     this.$router.push({
                        name: 'share'
                     })
                     Object.assign(this.$data, this.$options.data())
                  } catch (err) {
                     return 0
                  }
               }, 8000)
            }
         },
      },
      methods: {
         // 难易程度选择
         isDifficultToChoose(val, val1) {
            this.DifficultToChoose = val
            this.IntegralLevel = val1
            console.log("路由传值：", val, val1);
         },
         // 数据初始化
         initData() {
            console.log("初始化时的数据", heidModels);
            if (parseInt(this.$route.params.id)) {
               this.modelId = parseInt(this.$route.params.id)
               var model_Id = this.modelId
               localStorage.setItem("modelId", model_Id)
            } else {
               model_Id = parseInt(localStorage.getItem("modelId"))
               this.modelId = model_Id

            }
            var model_Id = this.modelId
            this.model = this.modelImportJson.model[model_Id]
            const model = this.modelImportJson.model[model_Id]
            this.heidModelsJson = this.modelImportJson.model[model_Id].SerialNumber
            for (var i = 0; i < this.heidModelsJson.length; i++) {
               if (this.heidModelsJson[i].isShow == false) {
                  this.heidJson.push(this.heidModelsJson[i])
               }
            }

            // console.log("重新构建后的模型图片数组：", newarr);
            console.log("模型图片：", this.heidJson);
            this.trueNum = this.modelImportJson.model[model_Id].trueNum
            if (this.trueNum == 3) {
               this.choosePlan = this.planImgT
               this.isPlanImg = this.choosePlan[0].src
            } else if (this.trueNum == 4) {
               this.choosePlan = this.planImgF
               this.isPlanImg = this.choosePlan[0].src
            }
         },
         init(modelJson) {
            this.isClearScene = true
            this.createScene() // 创建场景
            this.createLight(modelJson) // 创建光源
            this.createCamera('animate') // 创建相机
            this.createGeometry(modelJson)   // 创建模型
            this.createRender() // 创建渲染器
            this.render() // 渲染
            this.animate()
         },
         // 创建场景
         createScene() {
            // 创建场景
            scene = new THREE.Scene()
            const loader = new THREE.TextureLoader();
         },
         // 构建模型
         createGeometry(modelJson) {
            /* 构建正方体几何对象添加到场景中 */
            const _this = this
            const path = modelJson.modelPath
            const modelAnimatePath = modelJson.modelAnimatePath
            const nameObj = modelJson.SerialNumber
            const initModel = []
            const heidName = []
            // 获取显示和不显示的碎片名称
            nameObj.map(val => {
               if (val.isShow == true) {
                  initModel.push(val.name)
               } else {
                  heidName.push(val.name)
               }
            })
            const loadermodel = new FBXLoader();
            const loader = new FBXLoader();
            loader.load(modelAnimatePath, object => {
               mixer = new THREE.AnimationMixer(object);
               const action = mixer.clipAction(object.animations[0]);
               action.setLoop(THREE.LoopOnce)
               action.clampWhenFinished = true
               action.enable = true
               /*设置动画只播放一次*/
               action.play();
               scene.add(object);
               _this.modelLoading = false
               animatemodel = object;
               _this.animate()
               mixer.addEventListener('finished', function (e) {
                  _this.modelLoading = true
                  // _this.isGuide = JSON.parse(localStorage.getItem("isFirstLogin"))
                  scene.remove(object)
                  var a = sessionStorage.getItem("GAME_USERINFO")
                  var b = JSON.parse(a)
                  try {
                     var c = b.completed
                  } catch (err) {
                     var c = []
                  }
                  if (c.length == 0) {
                     _this.isGuide = true
                  } else {
                     _this.isGuide = false
                  }
                  setTimeout(() => {
                     loader.load(path, object => {
                        console.log("模型文件数据：", object);
                        _this.startTime()
                        _this.isAnimateEnd = true
                        _this.isReloadData = true
                        /*过滤错误零件*/
                        for (var i = 0; i < object.children.length; i++) {
                           let objTmp = object.children[i];
                           objects.push(objTmp) // 正确零件的拖动对象添加
                           // if (objTmp.name === initModel[])
                        }
                        // 需要玩家拖动的碎片列表
                        objects.map(itm => {
                           for (var i = 0; i < heidName.length; i++) {
                              if (itm.name == heidName[i]) {
                                 heidModels.push(itm)
                              }
                           }
                        })
                        // 渲染场景中固定的模型碎片
                        _this.modelLoading = false
                        objects.map(itm => {
                           for (var i = 0; i < initModel.length; i++) {
                              if (itm.name == initModel[i]) {
                                 scene.add(itm)
                              }
                           }
                        })
                     })
                  });
               }, 3000)
            });
            // function onLoad() {
            //    // 加载器解析文件
            //    console.log("模型加载完成！");
            // }
            // function onProgress(xhr) {
            //    // 后台打印查看模型文件加载进度
            //    console.log('加载完成的百分比',xhr);
            // }
         },
         // animate 动画
         animate() {
            requestAnimationFrame(this.animate);
            const delta = clock.getDelta();
            if (mixer) mixer.update(delta);
            renderer.render(scene, camera);
         },
         // 环境光
         createLight(light) {
            pointLight = new THREE.PointLight(0xffffff);
            directionalLight = new THREE.DirectionalLight(0xffffff, light.directionalLight);
            ambientLight = new THREE.AmbientLight(0xffffff);
            pointLight.distance = 0
            pointLight.castShadow = true;
            pointLight.position.set(new THREE.Vector3(400, 200, 300))
            pointLight.intensity = light.pointLight
            scene.add(pointLight); //点光源添加到场景中
            scene.add(ambientLight);
            scene.add(directionalLight);
         },
         // 创建相机
         createCamera(type) {
            var k = width / height; // 窗口宽高比
            var s = 1100; // 三维场景显示范围控制系数，系数越大，显示的范围越大  
            // var s = type === 'animate' ? 550 : 1100;
            camera = new THREE.OrthographicCamera(-s * k, s * k, s, -s, 1, 1900);
            camera.position.set(this.model.camera.x, this.model.camera.y, this.model.camera.z); // 设置相机位置
            camera.lookAt(scene.position); // 设置相机方向(指向的场景对象)
            this.initcameraX = Math.abs(camera.position.x)
            this.initcameraY = Math.abs(camera.position.y)
            this.initcameraZ = Math.abs(camera.position.z)
         },
         // 创建渲染器
         createRender() {
            sceneDomElement = document.getElementById("ThreeModel")
            var width = window.innerWidth; // 窗口宽度
            var height = window.innerHeight * 0.6 // 窗口高度
            renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
            orbitControls = new OrbitControls(camera, renderer.domElement);
            orbitControls.zoomSpeed = 2
            orbitControls.minZoom = 0.5;
            orbitControls.maxZoom = 3
            orbitControls.enablePan = false
            // orbitControls.minDistance = 0
            // orbitControls.maxDistance = 0
            // orbitControls.maxPolarAngle = 0;
            // orbitControls.minPolarAngle = 0;
            // orbitControls.update();
            renderer.setSize(width, height); // 设置渲染区域尺寸
            renderer.setClearColor(0xEEEEEE, 0.0);//或者renderer.setClearAlpha(0.0);它的意思是每次绘制清除缓冲区后的颜色通道设置，简单就是设置每次绘制的背景颜色
            sceneDomElement.appendChild(renderer.domElement); // body元素中插入canvas对象

         },
         render() {
            var vector = camera.position.clone();
            pointLight.position.set(vector.x, vector.y, vector.z); //点光源位置
            directionalLight.position.set(vector.x, vector.y, vector.z);
            orbitControls.update();
            /* 执行渲染 */
            // console.log("缩放参数",orbitControls.position0);
            if (this.isGuide) {
               if (Math.abs(Math.abs(camera.position.x) - this.initcameraX) > 100
                  || Math.abs(Math.abs(camera.position.y) - this.initcameraY) > 100
                  || Math.abs(Math.abs(camera.position.z) - this.initcameraZ) > 100) {
                  this.isGuide = false
                  localStorage.setItem("isFirstLogin", false)
                  document.getElementById("gifup").style = "display:flex"
               }
            }
            // console.log(camera.position.x,camera.position.y,camera.position.z,);
            requestAnimationFrame(this.render);
            renderer.render(scene, camera); //执行渲染操作，指定场景、相机作为参数
         },
         //高亮显示模型（呼吸灯）
         outlineObj(obj, colors) {
            obj.material = new THREE.MeshPhysicalMaterial({
               color: colors,
               metalness: 0.5,
               opacity: 0.5,
               roughness: 0.8,
            })
         },
         touchstart(e) {
            var serialNumber = e.currentTarget.getAttribute("serial-number")
            this.offsetX = 0;
            this.offsetY = 0;
            this.mouseY = 0
            let element = e.targetTouches[0]
            this.offsetX = element.clientX
            this.offsetY = element.clientY
            this.islight = true
            this.oldColor = heidModels[serialNumber].material
         },
         touchmove(e) {
            // console.log(camera.position.x,camera.position.y,camera.position.z);
            var serialNumber = e.currentTarget.getAttribute("serial-number")
            // var rotateStart = new THREE.Vector2();
            console.log(e);
            let element = e.targetTouches[0]
            // 根据初始 client 位置计算移动距离
            let x = element.clientX - this.offsetX
            let y = element.clientY - this.offsetY
            this.offsetXEnd = element.clientX
            this.offsetYEnd = element.clientY
            const mouseX = element.clientX;
            const mouseY = element.clientY
            this.mouseY = mouseY
            const xx = (mouseX / window.innerWidth) * 2 - 1;
            const yy = -((mouseY * 1) / window.innerHeight * 1.2) * 2 + 1;
            // const yy = -(mouseY / window.innerHeight) * 2 + 1;
            const up = Math.abs(x) < Math.abs(y) && y < 0
            console.log(mouseY);
            if (mouseY < 1400 && mouseY != 0) {
               // if (up) {
               this.StitchingStatus = true
               // if ((this.offsetY - element.clientY) > 50 && (this.offsetY - element.clientY)>0) {
               const stdVector = new THREE.Vector3(xx, yy, 0.8);
               const worldVector = stdVector.unproject(camera);
               if (camera.position.y > -1055 && camera.position.y < -1040) {
                  heidModels[serialNumber].position.y = worldVector.y - 900
                  heidModels[serialNumber].position.x = worldVector.x
                  heidModels[serialNumber].position.z = worldVector.z
               } else if (camera.position.y < 1053 && camera.position.y > 1040) {
                  heidModels[serialNumber].position.y = worldVector.y + 900
                  heidModels[serialNumber].position.x = worldVector.x
                  heidModels[serialNumber].position.z = worldVector.z
               } else if (camera.position.z < 1055 && camera.position.z > 1040) {
                  heidModels[serialNumber].position.y = worldVector.y
                  heidModels[serialNumber].position.x = worldVector.x
                  heidModels[serialNumber].position.z = worldVector.z + 900
               } else if (camera.position.z > -1060 && camera.position.z < -900) {
                  heidModels[serialNumber].position.y = worldVector.y
                  heidModels[serialNumber].position.x = worldVector.x
                  heidModels[serialNumber].position.z = worldVector.z - 900
               }
               else if (camera.position.y > -1060 && camera.position.y < -1040) {
                  heidModels[serialNumber].position.y = worldVector.y
                  heidModels[serialNumber].position.x = worldVector.x
                  heidModels[serialNumber].position.z = worldVector.z - 900
               } else if (camera.position.x < 1000 && camera.position.x > 1060) {
                  heidModels[serialNumber].position.y = worldVector.y + 900
                  heidModels[serialNumber].position.x = worldVector.x
                  heidModels[serialNumber].position.z = worldVector.z
               }
               else {
                  heidModels[serialNumber].position.y = worldVector.y
                  heidModels[serialNumber].position.x = worldVector.x
                  heidModels[serialNumber].position.z = worldVector.z
               }
               // 移动过程中是否处于正确坐标范围
               // console.log(heidModels[serialNumber].position.x,heidModels[serialNumber].position.y,heidModels[serialNumber].position.z);
               const isTrueX = this.heidJson[serialNumber].x
               const isTrueY = this.heidJson[serialNumber].y
               const isTrueZ = this.heidJson[serialNumber].z
               // console.log(isTrueX,isTrueY,isTrueZ);
               const x = heidModels[serialNumber].position.x
               const y = heidModels[serialNumber].position.y
               const z = heidModels[serialNumber].position.z
               const isX = heidModels[serialNumber].position.x > isTrueX - this.DifficultToChoose && heidModels[serialNumber].position.x < isTrueX + this.DifficultToChoose
               const isY = heidModels[serialNumber].position.y > isTrueY - this.DifficultToChoose && heidModels[serialNumber].position.y < isTrueY + this.DifficultToChoose
               const isZ = heidModels[serialNumber].position.z > isTrueZ - this.DifficultToChoose && heidModels[serialNumber].position.z < isTrueZ + this.DifficultToChoose
               const errX = x > isTrueX - 200 && x < isTrueX - 100 || x < isTrueX + 200 && x > isTrueX + 100
               const errY = y > isTrueY - 200 && y < isTrueY - 100 || y < isTrueY + 200 && y > isTrueY + 100
               const errZ = z > isTrueZ - 200 && z < isTrueZ - 100 || z < isTrueZ + 200 && z > isTrueZ + 100
               // if (this.islight) {
               // console.log(heidModels[serialNumber].material);
               if ((isX && isY) || (isX && isZ) || (isY && isZ)) {
                  // if ((isX && isZ)) {
                  this.islight = false
                  this.outlineObj(heidModels[serialNumber], "green")
                  isGreen = true
               } else if ((errX && errY) || (errX && errZ) || (errY && errZ)) {
                  this.outlineObj(heidModels[serialNumber], "red")
               } else {
                  heidModels[serialNumber].material = this.oldColor
               }
               scene.add(heidModels[serialNumber])   // 将  serialNumber  号模型加入到场景
               try {
                  element.target.style.cssText = `transform: translate(${mouseX}px, ${mouseY}px);`
               } catch (err) {
                  heidModels[serialNumber].material = this.oldColor
                  return 0
               }
            } else {
               this.StitchingStatus = false
               try {
                  element.target.style.cssText = `transform: none;`
                  heidModels[serialNumber].material = this.oldColor
               } catch (err) {
                  return 0
               }
               scene.remove(heidModels[serialNumber])
            }

         },

         touchend(e) {
            // this.endcamareEndX = camera.position.x
            const serialNumber = parseInt(e.currentTarget.getAttribute("serial-number"))
            var that = this
            that.test1 = that.mouseY
            if (this.mouseY < 600) {
               var a = document.getElementById("gifup")
               if (a) {
                  a.remove()
               }
            }
            if ((this.mouseY < 724 && this.mouseY != 0 && this.StitchingStatus) || isGreen) {
               const isTrueX = this.heidJson[serialNumber].x
               const isTrueY = this.heidJson[serialNumber].y
               const isTrueZ = this.heidJson[serialNumber].z
               const x = heidModels[serialNumber].position.x
               const y = heidModels[serialNumber].position.y
               const z = heidModels[serialNumber].position.z
               const isX = heidModels[serialNumber].position.x > isTrueX - this.DifficultToChoose && heidModels[serialNumber].position.x < isTrueX + this.DifficultToChoose
               const isY = heidModels[serialNumber].position.y > isTrueY - this.DifficultToChoose && heidModels[serialNumber].position.y < isTrueY + this.DifficultToChoose
               const isZ = heidModels[serialNumber].position.z > isTrueZ - this.DifficultToChoose && heidModels[serialNumber].position.z < isTrueZ + this.DifficultToChoose
               if ((isX && isY) || (isX && isZ) || (isY && isZ) || isGreen) {
                  // 拼接成功
                  heidModels[serialNumber].material = this.oldColor
                  this.$refs.threed_bgm.playMu(this.music.success)
                  heidModels[serialNumber].position.y = isTrueY
                  heidModels[serialNumber].position.x = isTrueX
                  heidModels[serialNumber].position.z = isTrueZ
                  scene.add(heidModels[serialNumber])
                  this.continuousSuccessNum = this.continuousSuccessNum + 1
                  this.allSuccess = this.allSuccess + 1
                  this.continuousErrorNum = 0
                  this.heidJson[serialNumber].status = true
                  try {
                     if (this.IntegralLevel == 1) {
                        this.integralFun(0.3)
                     } else if (this.IntegralLevel == 2) {
                        this.integralFun(1)
                     }

                  } catch (err) {
                     console.log(err);
                  }
               } else {
                  // 判断鼠标位置是否在模型区域内
                  console.log(Math.abs(this.offsetYEnd - window.innerHeight * 0.6 / 2));
                  if (Math.abs(this.offsetYEnd - window.innerHeight * 0.6 / 2) > 254) {
                     scene.remove(heidModels[serialNumber])
                     try {
                        heidModels[serialNumber].material = this.oldColor
                        e.target.style.cssText = `transform: none;`
                        scene.remove(heidModels[serialNumber])
                     } catch (err) {
                        return 0
                     }
                  } else {
                     this.$refs.threed_bgm.playMu(this.music.losed)
                     this.continuousErrorNum = this.continuousErrorNum + 1
                     scene.remove(heidModels[serialNumber])
                     try {
                        heidModels[serialNumber].material = this.oldColor
                        scene.remove(heidModels[serialNumber])
                        e.target.style.cssText = `transform: none;`
                     } catch (err) {
                        return 0
                     }
                     this.continuousSuccessNum = 0
                  }
               }
            } else {
               try {
                  e.target.style.cssText = `transform: none;`
                  scene.remove(heidModels[serialNumber])
               } catch (err) {
                  return 0
               }
            }

            isGreen = false;
         },
         // 取消
         touchcancel(e) {
            // console.log('cancel', e.path[0].id)
            const serialNumber = e.path[0].getAttribute("serial-number")
            scene.remove(heidModels[serialNumber])
            e.target.style.cssText = `transform: none;`
         },
         // 计时
         startTime() {
            console.log("开始计时");
            let that = this
            that.timer = setInterval(function () {
               that.timeNum = that.timeNum + 0.1
            }, 100)
         },
         // 清空计时器
         stopTime() {
            console.log("停止计时");
            this.timeNum = 0
            this.timer = clearInterval(this.timer)
         },
         // 积分规则
         integralFun(val) {
            let that = this
            if (that.timeNum < 1) {
               that.integral = Math.round(that.integral + 120 * val)
            } else if (that.timeNum >= 1 && that.timeNum < 2) {
               that.integral = Math.round(that.integral + 100 * val)
            } else if (that.timeNum >= 2 && that.timeNum < 3) {
               that.integral = Math.round(that.integral + 80 * val)
            } else if (that.timeNum >= 3 && that.timeNum < 4) {
               that.integral = Math.round(that.integral + 60 * val)
            } else if (that.timeNum >= 4 && that.timeNum < 5) {
               that.integral = Math.round(that.integral + 50 * val)
            } else if (that.timeNum >= 5 && that.timeNum < 6) {
               that.integral = Math.round(that.integral + 40 * val)
            } else if (that.timeNum >= 6 && that.timeNum < 7) {
               that.integral = Math.round(that.integral + 35 * val)
            } else if (that.timeNum >= 7 && that.timeNum < 8) {
               that.integral = Math.round(that.integral + 30 * val)
            } else if (that.timeNum >= 8 && that.timeNum < 9) {
               that.integral = Math.round(that.integral + 25 * val)
            } else if (that.timeNum >= 9 && that.timeNum < 10) {
               that.integral = Math.round(that.integral + 20 * val)
            } else {
               that.integral = Math.round(that.integral + 15 * val)
            }
         },
         // 积分提交
         async submitIntegral(currentIntegral) {
            localStorage.setItem("CurrentHighestIntegral",currentIntegral)
            let usr = sessionStorage.getItem("COVER_USERINFO");
            let user = JSON.parse(usr);
            let id = Number(localStorage.getItem("modelId")) + 1
            if (currentIntegral - this.highestIntegral > 0) {
               // 执行提交请求
               console.log("提交当前积分");
               let scoredata = await this.$request(
                  "/temporary/dggcwlj/score",
                  {
                     aid: "631ff5bf43b09f005038d8bd",
                     userinfo: user,
                     level: id,
                     score: currentIntegral,
                     time: 10,
                  },
                  "post"
               ).catch((res) => {
                  console.log("保存积分接口错误", res);
               });
               localStorage.setItem("code", scoredata.code)
            } else {
               console.log("不提交");
            }
         },
         // 清空场景，包括 scene 场景下的动画，子物体，renderer,camera,control，以及自己使用过的变量置空处理 等
         clearScene() {
            // 场景中的参数释放清理或者置空等
            if (this.isClearScene) {
               cancelAnimationFrame(this.render);
               cancelAnimationFrame(this.animate)
               scene.traverse((child) => {
                  if (child.material) {
                     child.material.dispose();
                  }
                  if (child.geometry) {
                     child.geometry.dispose();
                  }
                  child = null;
               });
               sceneDomElement.innerHTML = '';
               renderer.forceContextLoss();
               renderer.dispose();
               scene.clear();
               console.log('clearScene');
            }
         },
         // 重玩
         restartBtn() {
            this.$refs.threed_bgm.playMu(this.music.general)
            try {
               this.stopTime()
               this.isGameOver = false
               this.clearScene()
               Object.assign(this.$data, this.$options.data())
            } catch (err) {
               this.$router.push('/refresh')
            }
            this.$router.push('/refresh')
            location.reload();
         },
         // 返回首页
         returnHome() {
            this.$refs.threed_bgm.playMu(this.music.general)
            this.stopTime()
            this.isGameOver = false
            this.clearScene()
            Object.assign(this.$data, this.$options.data())
            this.$router.push('/')
         },
         // 返回按钮 关闭遮罩层
         skipBtn() {
            this.stopTime()
            this.$refs.threed_bgm.playMu(this.music.general)
            this.isGameOver = false
            clearTimeout(this.setTime)
            this.$router.push({
               name: "share",
            })
            try {
               this.stopTime()
               this.isGameOver = false
               this.clearScene()
               Object.assign(this.$data, this.$options.data())
            } catch (err) {
               return 0
            }
         },
         // 获取当前模型最高分
         async getHscore(val) {
            let usr = sessionStorage.getItem("COVER_USERINFO");
            let homeuserData = JSON.parse(JSON.stringify(this.userInfo));
            var user;
            if (usr != null) {
               user = JSON.parse(usr);
            }
            let maxdata = await this.$request(
               "/temporary/dggcwlj/max",
               { aid: this.aid, userinfo: user, level: val },
               "post"
            ).catch((res) => {
               console.log("历史最高分信息错误", res);
            });
            this.highestIntegral = maxdata.score
         },
         // 获取用户游戏信息
         async getUserGameInfo() {
            let usr = sessionStorage.getItem("COVER_USERINFO");
            let user = JSON.parse(usr);
            let usrGamedata = await this.$request(
               "/temporary/dggcwlj/user",
               { aid: this.aid, userinfo: user },
               "post"
            ).catch((res) => {
               console.log("用户游戏信息测试数据错误", res);
            });
            this.gameInfo = usrGamedata
            console.log("用户游戏数据，", usrGamedata);
         },
         // 是否需要触发彩蛋
         isEggs() {
            const completedObj = this.gameInfo.completed
            // const completedObj = []
            const modelId = JSON.parse(localStorage.getItem("modelId"))
            var isEggsvar = true
            for (var key in completedObj) {
               if (completedObj[key] == modelId + 1 && completedObj.length == 6) {
                  isEggsvar = false
               } else if (completedObj.length < 6) {
                  isEggsvar = false
               } else if (completedObj.length == 7) {
                  isEggsvar = false
               }
            }
            if (completedObj.length == 0) {
               isEggsvar = false
            }
            setTimeout(() => {
               sessionStorage.setItem("color_egg", JSON.stringify(isEggsvar))
            }, 300);

         },
         // 打开或者关闭提示
         openHint() {
            const _this = this
            _this.isHint = false
         },
         closeHint() {
            const _this = this
            _this.isHint = true
         },

      },
   }
</script>



<style lang="less" scoped>
   .model_loading {
      position: absolute;
      height: 100vh;
      width: 100vh;
      background-color: rgba(0, 0, 0, 0.685);
      z-index: 999;
      .model_loading_div {
         text-align: center;
         width: 30vw;
         line-height: 3vh;
         /* margin: 0 auto; */
         /* left: 20vw; */
         color: #ffff;
         font-size: 4vw;
         font-weight: bold;
         margin-left: 34vw;
         margin-top: 46vh;
         img {
            width: 20vw;
         }
      }
   }

   // 模型动画提示
   .model_gif_btn {
      position: absolute;
      top: 0;
      height: 9vh;
      width: 9vh;
      right: -0.3vh;
      top: 8vh;
   }
   .model_gif_btn2 {
      position: absolute;
      // height: 9vh;
      width: 15vh;
      right: 0.7vh;
      top: 9vh;
      z-index: 1;
   }
   .isShowGif {
      top: 8.5vh;
      position: absolute;
      right: 0;
      background-image: url("../assets/spicing_slip_bg.png");
   }
   // 难度选择
   .chooseEasy {
      position: absolute;
   }
   .gif {
      position: absolute;
      top: 36vh;
      z-index: 9999;
      pointer-events: none;
   }
   .gif-up {
      position: absolute;
      bottom: -13vh;
      z-index: 999;
      left: 5vh;
      width: 5vh;
      pointer-events: none;
   }
   .gif-up-box {
      display: none;
      width: 100%;
      position: absolute;
      bottom: 16vh;
      z-index: 999;
      pointer-events: none;

      margin: 0 auto;
      p {
         color: #298bf5;
         font-size: 2.2vh;
         text-align: center;
         font-weight: bold;
         width: 100vw;
      }
   }
   .gif-up {
      animation: myMove 1.7s linear infinite;
      animation-fill-mode: forwards;
   }
   @keyframes myMove {
      0% {
         transform: translateY(0);
      }
      100% {
         transform: translateY(-20vh);
      }
   }
   .plus-icon-enter-active {
      transition: opacity 5s;
   }
   .plus-icon-enter {
      opacity: 1;
   }
   .plus-icon-leave-active {
      transition: opacity 5s;
   }
   .plus-icon-leave-to {
      opacity: 0;
   }
   #ThreeModel {
      position: absolute;
      top: 26vh;
      height: 61vh;
   }
   .bg {
      background-size: 100% 100%;
      padding: 0px;
      overflow: hidden;
      background-repeat: no-repeat;
   }
   .Three_top {
      width: 100%;
      height: 100%;
      padding-top: 20px;
      font-weight: bold;
      letter-spacing: 4px;
      .return {
         padding-left: 25px;
         color: white;
         font-size: 2vh;
         display: flex;
         width: 79%;
         height: 5.42vh;
         font-weight: bold;
         background-image: url("../../static/pageImg/common/common_btn_bg.png");
         .Activity_text_1 {
            // height: 100%;
            // position: relative;
            // top: 29%;
            height: 5.42vh;
            line-height: 5.42vh;
         }
         .Activity_text_2 {
            height: 1.5vh;
            width: 1.5vh;
            position: relative;
            /* top: 35%; */
            line-height: 5.6vh;
            margin-left: 20px;
            img {
               height: 100%;
            }
         }
      }
      .title_text {
         width: 48vh;
         height: 10vh;
         margin: 0 auto;
         margin-top: 3.6vh;
         // background-image: url("../../static/pageImg/splicing/splicing_title_ganzhuao.png");
      }
      .score {
         width: 36vh;
         display: flex;
         margin: 0 auto;
         .score_img {
            width: 16.5vh;
            height: 6vh;
            background-image: url("../../static/pageImg/splicing/splicing_tab_scoring.png");
            p {
               color: white;
               text-align: right;
               line-height: 6.5vh;
            }
         }
         .score_img_score {
            width: 17vh;
            height: 6vh;
            background-image: url("../../static/pageImg/splicing/splicing_tab_scoring_again.png");
            p {
               width: 13vh;
               color: #ffffff;
               letter-spacing: 0.2vh;
               line-height: 2.5vh;
            }
         }
         .plan {
            margin-left: 1vh;
            width: 26vh;
            height: 6vh;
            // background-image: url("../../static/pageImg/splicing/splicing_prograss_three_s.png");
            img {
               height: 100%;
               width: 100%;
            }
         }
      }
   }
   .ThreeD_body {
      width: 100%;
      height: 100vh;
      background-image: url("../../static/pageImg/common/common_bg_ganzhuao.png");
   }
   .grid {
      width: 100%;
      height: 13vh;
      bottom: 0;
      display: flex;
      position: absolute;
      background-image: url("../../static/pageImg/common/common_modle_display_bg.png");
   }
   .box_model_card {
      z-index: 2;
      width: 100%;
      height: 17vh;
      // display: flex;
      bottom: 0;
      position: absolute;
      overflow-x: scroll;
      white-space: nowrap;
   }
   .model_card_cell {
      // white-space:nowrap;
      display: inline-block;
      height: 100%;
      margin-left: 2vh;
   }
   .box-red0 {
      background-image: url("../../static/pageImg/splicing/01.jpg") !important;
   }
   .box-red1 {
      background-image: url("../../static/pageImg/splicing/02.jpg") !important;
   }
   .box-red2 {
      background-image: url("../../static/pageImg/splicing/03.jpg") !important;
   }
   .box-red3 {
      background-image: url("../../static/pageImg/splicing/04.jpg") !important;
   }
   .box-red {
      height: 14vh;
      width: 14vh;
      background-image: url("../../static/pageImg/splicing/splicing_modle_bg.png");
      // display: table-cell;
      // vertical-align: middle;
      // text-align: center;
      animation: forward 4s;
      img {
         /* position: fixed; */
         width: 100%;
         height: 100%;
         touch-action: none;
      }
   }
   .xxxIndex0 {
      // display: none !important;
   }
   .gameOver {
      top: 0;
      z-index: 9999;
      width: 100%;
      height: 100vh;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.438);
      .gameOver_Lose {
         margin: 0 auto;
         margin-top: 30vh;
         width: 43vh;
         height: 42vh;
         img {
            width: 100%;
            height: 100%;
         }
         .restartBtn {
            z-index: 10;
            width: 28vh;
            height: 6.2vh;
            margin: 0 auto;
            position: relative;
            top: -17vh;
         }
         .returnHome {
            z-index: 10;
            margin: 0 auto;
            width: 9vh;
            height: 3vh;
            position: relative;
            top: -15vh;
         }
      }
      .gameOver_Success {
         margin: 0 auto;
         margin-top: 10vh;
         width: 43vh;
         .top_text {
            text-align: center;
            font-size: 3.4vh;
            height: 6vh;
            font-weight: bold;
            color: white;
            letter-spacing: 0.5vh;
            padding-top: 3vh;
            background-image: url("../../static/pageImg/splicing/splicing_pop_top.png");
            span {
               color: #ffe636;
            }
         }
         .content_box {
            background-image: url("../../static/pageImg/splicing/splicing_pop_bg.png");
            .skipBtn {
               padding: 2vh;
               text-align: right;
               img {
                  float: right;
                  width: 35%;
                  height: 100%;
               }
            }
            .modelShow {
               // background-image: url("../../static/pageImg/splicing/splicing_pop_modle_bg.png");
               height: 43vh;
               width: 43vh;
               margin-top: -7vh;
               img {
                  height: 100%;
                  width: 100%;
               }
            }
            .introduceContent {
               font-size: 1.5vh;
               padding: 0px 4vh;
               text-align: justify;
            }
            .maohao {
               font-size: 4vh;
               font-weight: bold;
               color: #0b7df9;
               height: 3vh;
               padding-left: 2vh;
               padding-right: 2vh;
            }
            .maohao_right {
               text-align: right;
            }
            .bottom_box {
               padding: 2.3vh;
               margin-bottom: 3vh;
               text-align: center;
               background: linear-gradient(
                  to right,
                  rgba(10, 125, 250, 0.1) 0%,
                  rgba(10, 125, 250, 0.8) 50%,
                  rgba(10, 125, 250, 0.1) 100%
               );
               font-size: 2.2vh;
               letter-spacing: 0.2vh;
               font-weight: bold;
               color: #ffffff;
               span {
                  color: #ffe63b;
               }
               .bottonTT {
                  color: #ffe63b;
               }
            }
         }
      }
   }
</style>
